import Logo from 'images/logo.svg'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const Fallback = () => (
  <Box
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: (theme) => theme.zIndex.modal + 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 5,
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
    }}
  >
    <img src={Logo} style={{ width: '250px' }} alt="OMS logo" />
    <div>
      <Typography variant="body1" sx={{ fontWeight: 600 }}>
        Uh Oh! Looks like there was an error
      </Typography>
      <Typography>Please try again or contact OMS Support.</Typography>
    </div>
  </Box>
)
